// React and Hooks
import React, { useEffect, useMemo, useState } from 'react';
import { useFetchData } from '../../../../hooks/useFetchData/useFetchData';
import { useDebounce } from '../../../../hooks/useDebounce/useDebounce';

//Frameworks 
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import moment from 'moment-timezone';
import timezone from 'dayjs/plugin/timezone';
//Components
import RequestCard from '../../../../components/requests/cards/RequestCard';
import RequestAdmin from '../../../../components/requests/requestsModais/requestAdmin/requestAdmin';
import RequestConclude from '../../../../components/requests/requestsModais/requestConclude/requestConclude';
import RequestSelectUser from '../../../../components/requests/requestsModais/requestSelectUser/requestSelectUser';
import { RequestsHeader } from '../../../../components/requests/requestHeader/requestsHeader';
import { useShowMessages } from '../../../../hooks/useMessages/useMessages';
import StatusBar from '../../../../components/status/StatusBar';

//Styles -- Mui
import { Badge, Box, Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, IconButton,
         Menu, MenuItem, SpeedDial, SpeedDialAction, SpeedDialIcon, TextField, Tooltip } from '@mui/material';
import PostAddIcon from '@mui/icons-material/PostAdd';
import FilterListIcon from '@mui/icons-material/FilterList';
import './panelPage.css';
import RequestClient from '../../../../components/requests/requestsModais/requestClient/requestClient';
import RequestAddService from '../../../../components/requests/requestsModais/requestAddService/requestAddService';
import { useCryptoSessionStorage } from '../../../../hooks/useCryptoSessionStorage';
import { Alert, AlertTitle } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';



let url = process.env.REACT_APP_API+ "/requests/user";
let urlStatus = process.env.REACT_APP_API+ "/requests/status";

// Período da coluna "Identificar Cliente". Os valores batem com a whitelist da API.
const pendingPeriods = [
  { value: 'month', label: 'Mês atual' },
  { value: 'last_month', label: 'Mês anterior' },
  { value: 'days30', label: 'Últimos 30 dias' },
  { value: 'days60', label: 'Últimos 60 dias' },
  { value: 'custom', label: 'Personalizado' },
];

moment.tz.setDefault('America/Manaus');
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('America/Manaus');

export default function RequestsPanelPage () {

  const { getData } = useCryptoSessionStorage();
  const user = getData("user") || {};
  const [request, setRequest] = useState({});
  const [openRequest, setOpenRequest] = useState(false);
  const [openRequestConclude, setOpenRequestConclude] = useState(false);
  const [openSelectUser, setOpenSelectUser ] = useState(false);
  const [openNewRequest, setOpenNewRequest] = useState(false);
  const [openAddService, SetOpenAddService] = useState(false);
  const [transfer, setTransfer] = useState(false);
  const [changed, setChanged ] = useState(false); 
  const { debounce } = useDebounce ();
  const typeFilter = sessionStorage.getItem('typeFilter');
  const userFilterId = sessionStorage.getItem('userFilterId');
  const userFilterName = sessionStorage.getItem('userFilterName');
  const groupFilterName = sessionStorage.getItem('groupFilterName');
  const groupFilterId = sessionStorage.getItem('groupFilterId');
  const orderBy = sessionStorage.getItem('requestsOrderBy');
  const orderDirection = sessionStorage.getItem('requestsOrderDirection');
  const priority = sessionStorage.getItem('requestsPriority');
  const ShowHiddenRequests = sessionStorage.getItem('show_hidden_requests');
  const pendingPeriod = sessionStorage.getItem('blipPendingPeriod');
  const pendingFrom = sessionStorage.getItem('blipPendingFrom');
  const pendingTo = sessionStorage.getItem('blipPendingTo');
  const [periodAnchor, setPeriodAnchor] = useState(null);
  const [openPeriodDialog, setOpenPeriodDialog] = useState(false);
  const [customRange, setCustomRange] = useState({
    from: pendingFrom || dayjs().startOf('month').format('YYYY-MM-DD'),
    to: pendingTo || dayjs().format('YYYY-MM-DD'),
  });
  const [blipStatus, setBlipStatus] = useState({ status: 'up', last_event_iso: null });
  const [showBlipAlert, setShowBlipAlert] = useState(true);
  const { ShowMessage } = useShowMessages();


  useEffect(() => {
    let timer = null;
    const fetchStatus = async () => {
      try {
        const resp = await fetch(process.env.REACT_APP_API + '/health/blip');
        if (resp.ok) setBlipStatus(await resp.json());
      } catch {}
      timer = setTimeout(fetchStatus, 60_000); // 1 min
    };
    fetchStatus();
    return () => clearTimeout(timer);
  }, []);

  const lastEventText = blipStatus?.last_event_ms
  ? dayjs(blipStatus.last_event_ms).tz('America/Porto_Velho').format('DD/MM/YYYY HH:mm:ss')
  : null;

  const [filter, setFilter] = useState({
    id: userFilterId || user?.id,
    name: userFilterName || user?.name,
    nameGroup: groupFilterName || user?.description,
    idGroup: groupFilterId || user?.id_group,    
    type: (typeFilter) ? typeFilter : 'user',   
    order: (orderBy) ? orderBy : 's.created_at',
    orderDirection: (orderDirection) ? orderDirection : 'ASC',
    priority: (priority) ? priority : 5,
    ShowHiddenRequests: (ShowHiddenRequests) ? ShowHiddenRequests : 'N',
    pendingPeriod: (pendingPeriod) ? pendingPeriod : 'month',
    pendingFrom: pendingFrom || undefined,
    pendingTo: pendingTo || undefined,
  });


  const { data: requests, editData } = useFetchData(url, filter, changed, true, false, true);

  const handleChanged = () => {
    setChanged(!changed);
  }

  const applyPendingPeriod = (period, range) => {
    sessionStorage.setItem('blipPendingPeriod', period);

    if (period === 'custom') {
      sessionStorage.setItem('blipPendingFrom', range.from);
      sessionStorage.setItem('blipPendingTo', range.to);
    } else {
      // Sem limpar, o intervalo antigo voltaria ao recarregar a página.
      sessionStorage.removeItem('blipPendingFrom');
      sessionStorage.removeItem('blipPendingTo');
    }

    setFilter((prev) => ({
      ...prev,
      pendingPeriod: period,
      pendingFrom: (period === 'custom') ? range.from : undefined,
      pendingTo: (period === 'custom') ? range.to : undefined,
    }));

    handleChanged();
  }

  const handleSelectPeriod = (period) => {
    setPeriodAnchor(null);

    if (period === 'custom') return setOpenPeriodDialog(true);

    applyPendingPeriod(period);
  }

  const handleApplyCustomPeriod = () => {
    if (dayjs(customRange.to).isBefore(dayjs(customRange.from))) {
      return ShowMessage('error', 'A data final não pode ser menor que a inicial.');
    }

    setOpenPeriodDialog(false);
    applyPendingPeriod('custom', customRange);
  }

  const periodLabel = (filter.pendingPeriod === 'custom' && filter.pendingFrom)
    ? `${dayjs(filter.pendingFrom).format('DD/MM/YYYY')} a ${dayjs(filter.pendingTo).format('DD/MM/YYYY')}`
    : (pendingPeriods.find((item) => item.value === filter.pendingPeriod)?.label || 'Mês atual');

  debounce((30*1000), () => {
    handleChanged();
  })

  const handleOpenNewRequest = () => {

    let newRequest = {
      creator_user: user?.id,
      user: (userFilterId) ? userFilterId : user?.id,
      sequence: 1,
      description: '',
      status: 1,
      type_service: 30,
      type_service_description: 'Acesso Remoto',
      type_request: 0,
      hide_panel: 'N',
      start_date: dayjs().utc(true).format()
    };



    setRequest(newRequest);
    setOpenNewRequest(true);
  }


  // Concluídos que ficaram no cadastro genérico (SIRRUS - CLIENTES BLIP) ganham uma coluna
  // só deles e não somem quando são revisados. Os em andamento seguem no fluxo normal, com
  // o chip BLIP! laranja, para não sair da fila de trabalho.
  const isPendingColumn = (item) => item?.pending_identification === 'Y' && Number(item?.status) >= 4;

  const requestsPendingIdentification = useMemo(() => {
    return (requests && requests?.filter(isPendingColumn)) || [];
  }, [requests])

  const newRequests = useMemo(() => {
    return requests && requests?.filter((item) => item.status ===  1);
  }, [requests])

  const requestsToDo = useMemo(() => {
    return requests && requests?.filter((item) => item.status ===  2);
  }, [requests])

  const  requestsDoing = useMemo(() => {
    return requests && requests?.filter((item) => item.status ===  3 || item.status ===  0);
  }, [requests])

  const  requestsDone = useMemo(() => {
    return requests && requests?.filter((item) => item.status ===  4 && !isPendingColumn(item));
  }, [requests])


  const removeCard = (origin, index) => {
    switch(origin){
      case '1': return newRequests.splice(index, 1);
      case '2': return requestsToDo.splice(index, 1);
      case '3': return requestsDoing.splice(index, 1);
      case '4': return requestsDone.splice(index, 1);
      default: return {};
    }
  }

  const includeCard = (dest, index, card) => {
    switch(dest){
      case '1': return newRequests.splice(index, 0, card);
      case '2': return requestsToDo.splice(index, 0, card);
      case '3': return requestsDoing.splice(index, 0, card);
      case '4': return requestsDone.splice(index, 0, card);
      default: return {};
    }
  }

  const handleListRequests = (status) => {
    switch (status) {
      case '1': return (newRequests && newRequests) ? newRequests : [{}];
      case '2': return (requestsToDo && requestsToDo) ? requestsToDo : [{}];
      case '3': return (requestsDoing && requestsDoing) ? requestsDoing : [{}];
      case '4': return (requestsDone && requestsDone) ? requestsDone : [{}];
      case '5': return requestsPendingIdentification;
      default: return [{}];
    }
  }

  const statusGroups = [
    { id: '1', status: 1, title: 'Novas Solicitações', color: 'error', count: newRequests.length},
    { id: '2', status: 2, title: 'Aguardando', color: 'warning', count: requestsToDo.length},
    { id: '3', status: 3, title: 'Em andamento', color: 'info', count: requestsDoing.length},
    { id: '4', status: 4, title: 'Concluídas', color: 'success', count: requestsDone.length},
    { id: '5', status: null, title: 'Identificar Cliente', color: 'warning', count: requestsPendingIdentification.length, pendingIdentification: true},
  ]

  const actions = [
    { icon: <PostAddIcon />, name: 'Novo Atendimento', action: handleOpenNewRequest },
  ];

  const handleConcludeRequest = () => {
    setOpenRequestConclude(true);
  }

  const handleConfirmRequest = () => {
    setTransfer(false);
    setOpenSelectUser(true);
  }

  const handleEditStatus = async (id, status, start_date) => {
    return await editData(urlStatus, {id, status, user: filter.id, start_date })
  }

  const handleOnDragEnd = (result) => {

    // Não permite voltar um atendimento para nova solicitação.
    if (!result.destination || result.destination.droppableId === '1' || result.destination.droppableId === result.source.droppableId ) return;

    // A coluna de identificação não é etapa do atendimento: sai dela trocando o cadastro.
    if (result.destination.droppableId === '5' || result.source.droppableId === '5') {
      ShowMessage('error', 'Para tirar o atendimento desta coluna, troque o cadastro do cliente.');
      return;
    }

    // Não permite concluir sem iniciar 
    if (result.destination.droppableId === '4' && result.source.droppableId != '3' ) {
       ShowMessage('error', 'Necessário iniciar o atendimento antes');
      return;
    };

    //Cria uma cópia do card que está sendo arrastado, e remove o mesmo coluna de origem, e insere na coluna de destino
    const card =  removeCard( result.source.droppableId, result.source.index, 1);
    includeCard(result.destination.droppableId, result.destination.index, card[0]);    

    const start_date = dayjs.tz().format();
    card[0].status = result.destination.droppableId;
    
    //Atualiza a hora de inicio/conclusão do atendimento 
    if(result.destination.droppableId === '3'){
      card[0].start_date = dayjs.tz(start_date).utc(true);
    } else if(result.destination.droppableId === '4'){
      if(user?.ignore_completion_time === 'Y'){
        card[0].conclusion_date = dayjs.tz(start_date).utc(true);
      } else {
        card[0].conclusion_date = null;
        card[0].start_date = null;
      }
    }

    if(result.destination.droppableId === '4'){
      setRequest(card[0]);
      handleConcludeRequest();
    } else 
    if(result.destination.droppableId === '2'){
      card[0].user = filter.id;
      setRequest(card[0]);
      if(!card[0]?.start_date){
        handleConfirmRequest();
      } else {
        handleEditStatus(result.draggableId, result.destination.droppableId);
      }

    } else {
      handleEditStatus(result.draggableId, result.destination.droppableId, dayjs(start_date).utc(true).format('YYYY-MM-DD HH:mm:ss'))
    }
    
  }

  return (
    <Box className="ServicesRequest" sx={{overflow: 'hidden', width: '100%', height: '100vh'}} >
      <header className="App-header">
        <RequestsHeader values={filter} setValues={setFilter} handleChanged={handleChanged} />
      </header>
        <RequestClient open={openNewRequest} setOpen={setOpenNewRequest} admin={true} handleChanged={handleChanged} requestsPage={true} values={request} setValues={setRequest}/> 
        <RequestAdmin values={request} open={openRequest} setValues={setRequest} setOpenRequest={setOpenRequest} handleChanged={handleChanged}  />
        <RequestConclude values={request} open={openRequestConclude} setValues={setRequest} setOpen={setOpenRequestConclude} handleChanged={handleChanged}/>
        <RequestSelectUser values={request} open={openSelectUser} setValues={setRequest} setOpen={setOpenSelectUser} handleChanged={handleChanged} transfer={transfer}  />
        <RequestAddService values={request} open={openAddService} setOpen={SetOpenAddService} setValues={setRequest} handleChanged={handleChanged} />
        <DragDropContext className='requests-area' onDragEnd={handleOnDragEnd}>
          <div className='request-container-groups'  >
            {statusGroups.map((group) => {
              return (              
                <div key={group.id} className={`statusGroups ${(group.pendingIdentification) ? 'statusGroups--pending' : ''}`}>
                  <div className="statusGroups-header" >
                  <Badge size="sm" className='request-counts' badgeContent={group.count} color={group.color} sx={{fontSize: '10px'}}   >
                    <Chip
                      className='request-title'
                      label={group.title}
                      size='small'
                      color={(group.pendingIdentification && group.count > 0) ? 'warning' : 'default'}
                      title={(group.pendingIdentification)
                        ? 'Atendimentos que ficaram no cadastro SIRRUS - CLIENTES BLIP. Abra o atendimento e troque para o cadastro correto do cliente.'
                        : ''}
                    />
                  </Badge>
                  {group.pendingIdentification && (
                    <>
                      <Tooltip title={`Período: ${periodLabel}`}>
                        <IconButton size="small" sx={{ ml: 0.5 }} onClick={(e) => setPeriodAnchor(e.currentTarget)}>
                          <FilterListIcon fontSize="small" color={(filter.pendingPeriod === 'month') ? 'action' : 'warning'} />
                        </IconButton>
                      </Tooltip>
                      {/* Fora do mês corrente o período fica à vista: senão a contagem
                          da coluna é lida como se fosse do mês. */}
                      {filter.pendingPeriod !== 'month' && (
                        <Chip
                          label={periodLabel}
                          size="small"
                          variant="outlined"
                          color="warning"
                          onClick={(e) => setPeriodAnchor(e.currentTarget)}
                          sx={{ alignSelf: 'center', maxWidth: 140 }}
                        />
                      )}
                    </>
                  )}
                  </div>
                    <Droppable droppableId={group.id}> 
                    {(provided) => (
                      <div className='statusGroups-body'>
                        <ul className="itemRequest" {...provided.droppableProps} ref={provided.innerRef} >

                          {handleListRequests(group.id)?.map((ticket, index) => {
                            if(ticket?.service_id){
                              return (
                                <Draggable
                                  key={ticket?.service_id}
                                  draggableId={ticket?.service_id.toString()}
                                  index={index}
                                  isDragDisabled={Boolean(group.pendingIdentification)}
                                >
                                  {(provided) => (
                                    <li ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                      <RequestCard
                                        admin={true}
                                        values={ticket}
                                        setRequest={setRequest}
                                        setOpenRequest={setOpenRequest}
                                        handleConcludeRequest={handleConcludeRequest}
                                        setOpenSelectUser={setOpenSelectUser}
                                        setTransfer={setTransfer}
                                        SetOpenAddService={SetOpenAddService}
                                        userFilter={userFilterId}
                                        pendingIdentification={Boolean(group.pendingIdentification)}
                                      />
                                    </li>
                                  )}
                                </Draggable>
                              );
                            }
                          })}
                          <li className='droppable-areaEmpty'>
                          
                          </li>                     
                        </ul>
                        {provided.placeholder}
                      </div> 
                    )}
                    </Droppable>
                </div>                 
              )
            })}
          </div>            
        </DragDropContext>
      <Menu anchorEl={periodAnchor} open={Boolean(periodAnchor)} onClose={() => setPeriodAnchor(null)}>
        {pendingPeriods.map((item) => (
          <MenuItem
            key={item.value}
            selected={item.value === filter.pendingPeriod}
            onClick={() => handleSelectPeriod(item.value)}
          >
            {item.label}
          </MenuItem>
        ))}
      </Menu>
      <Dialog open={openPeriodDialog} onClose={() => setOpenPeriodDialog(false)}>
        <DialogTitle>Período dos atendimentos a identificar</DialogTitle>
        {/* O MUI zera o padding-top do DialogContent que vem depois do DialogTitle
            (`.MuiDialogTitle-root + .MuiDialogContent-root`), e isso recorta o label
            encolhido dos campos de data. O seletor com a própria classe empata em
            especificidade e vence por ordem de injeção. */}
        <DialogContent
          sx={{
            display: 'flex',
            gap: 2,
            overflow: 'visible',
            '&.MuiDialogContent-root': { pt: 1.5 },
          }}
        >
          <TextField
            label="De" type="date" size="small" value={customRange.from}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setCustomRange({ ...customRange, from: e.target.value })}
          />
          <TextField
            label="Até" type="date" size="small" value={customRange.to}
            InputLabelProps={{ shrink: true }}
            onChange={(e) => setCustomRange({ ...customRange, to: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenPeriodDialog(false)}>Cancelar</Button>
          <Button
            variant="contained"
            disabled={!customRange.from || !customRange.to}
            onClick={handleApplyCustomPeriod}
          >
            Aplicar
          </Button>
        </DialogActions>
      </Dialog>
      <Box sx={{  transform: 'translateZ(0px)', flexGrow: 1 }}>
        <SpeedDial
          ariaLabel="SpeedDial Actions"
          sx={{ position: 'fixed', bottom: 20, right: 8}}
          icon={<SpeedDialIcon />}
        >
          {actions.map((action) => (
            <SpeedDialAction
              key={action.name}
              icon={action.icon}
              tooltipTitle={action.name}
              onClick={action.action}
            />
          ))}
        </SpeedDial>
      </Box>
      {blipStatus?.status === 'down' && showBlipAlert && (
      <Alert
        icon={<WifiOffIcon />}
        severity="warning"
        variant="outlined"
        onClose={() => setShowBlipAlert(false)}
        sx={{
          position: 'fixed',
          left: 16,
          right: 16,
          bottom: 16,
          zIndex: 1300,
          borderRadius: 10,
          bgcolor: '#1F2937',            // cinza-800 sólido
          color: '#E5E7EB',              // cinza-200
          borderColor: '#22D3EE',        // ciano na borda
          '& .MuiAlert-icon': { color: '#22D3EE' },
        }}
      >
        <AlertTitle sx={{ fontWeight: 700, color: '#BAE6FD', mb: 0.25 }}>
          Serviços Blip indisponíveis
        </AlertTitle>
        Atenção: sem eventos da Blip há ≥10 min (horário PV-RO)
        {lastEventText ? ` — último evento às ${lastEventText}.` : '.'}
        <br />
        <strong>Enquanto o serviço da Blip estiver fora do ar, crie os atendimentos manualmente.</strong>
      </Alert>
    )}
    <StatusBar />
    </Box>
  )
}
